// Ring 0 — share-card configuration constants (D-EM-04).
//
// SHARE_BASE_URL targets the production domain placeholder; resolveShareBaseUrl()
// returns the live origin during dev (localhost) and Cloudflare Pages preview
// deploys (*.pages.dev) so shared `?seed=N` links round-trip during pre-production.
// Phase 5 hardens the production domain.
//
// NO Phaser imports.

export const SHARE_BASE_URL = 'https://degenkong.fun';

/** Resolve the runtime share base URL with dev fallback (D-EM-04). */
export function resolveShareBaseUrl(): string {
  if (typeof window === 'undefined') return SHARE_BASE_URL;
  const { origin, pathname } = window.location;
  if (origin.startsWith('http://localhost') || origin.endsWith('.pages.dev')) {
    return `${origin}${pathname}`;
  }
  return SHARE_BASE_URL;
}
